import { RepeatType } from 'components/Frequency/constants'
import { InputType } from 'config'

export const defaultReminderInputs = (loanGlobalStatus: any, reminderId: number): Record<string, InputType> => {
  return {
    assignedTo: {
      inputType: 'multiselect',
      title: 'Assigned To',
      options: {},
      required: true,
      value: [],
    },
    date: {
      inputType: 'text',
      type: 'date',
      title: 'Remind Date',
      required: true,
    },
    loanNumber: {
      inputType: 'text',
      type: 'number',
      title: 'Loan Number',
      required: false,
    },
    completeAt: {
      inputType: 'multiselect',
      title: 'Complete At',
      options: loanGlobalStatus,
      defaultSelected: false,
    },
    description: {
      inputType: 'textarea',
      title: 'Description',
      rows: 6,
      required: true,
    },
    files: {
      inputType: 'filetable',
      title: 'Files',
      required: false,
      acceptFileTypes: '.pdf, .msg, .xls, .xlsx',
      multiple: true,
      span: 'full',
      showCategory: false,
      showStatus: false,
      filePath: `reminder/${reminderId}`,
    },
  }
}

export enum ReminderStatus {
  ACTIVE = 'active',
  COMPLETED = 'completed',
}

export const ReminderStatusLabel = {
  [ReminderStatus.ACTIVE]: 'Active',
  [ReminderStatus.COMPLETED]: 'Completed',
}

export interface IReminder {
  id: number
  no: number
  date: string
  loanNumber: number | null
  description: string
  assignedTo: string[]
  status: ReminderStatus
  createdAt: string
  updatedAt: string
  frequency: Record<string, any>
}

export const reminderInitialData = (): Record<string, any> => {
  return {
    frequency: {
      repeatType: RepeatType.NoRepeat,
    },
  }
}
